export default __webpack_public_path__ + "static/media/h11.d7a702ca.jpg";